module.exports = __webpack_public_path__ + "img/page-18.0e61e3bc.jpg";